import { render } from "./heshtalmotList.vue?vue&type=template&id=3812f6b3"
import script from "./heshtalmotList.vue?vue&type=script&lang=js"
export * from "./heshtalmotList.vue?vue&type=script&lang=js"

import "./heshtalmotList.vue?vue&type=style&index=0&id=3812f6b3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__